const logos = [
    require('@/assets/page/partners/automatic/logo1.png'),
    require('@/assets/page/partners/automatic/logo2.png'),
    require('@/assets/page/partners/automatic/logo3.png'),
    require('@/assets/page/partners/automatic/logo4.png'),
];

export default logos;